module.exports = __webpack_public_path__ + "img/changeManager.1c0cc2c5.svg";